import type { CSSProperties } from "react";

import { stringToHSL } from "@/lib/string-to-hsl";

export function getBadgeInlineStyle(
  variant: string | null | undefined,
  extras: { hash?: string; color?: string }
): CSSProperties {
  if (variant === "hash") {
    const { backgroundColor } = stringToHSL(extras.hash ?? "");
    return { backgroundColor, outlineColor: backgroundColor };
  }

  if (variant === "color") {
    const color = extras.color ?? "";
    return {
      backgroundColor: `oklch(${color} / 0.1)`,
      color: `oklch(${color})`,
      borderColor: `oklch(${color} / 0.1)`,
    };
  }

  return {};
}
